import { Button } from '@chakra-ui/react'
import { useFormContext } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'

//Slice
import { showApprovalRemarkModal } from '@/stores/offers/offersSlice'

import { authSelector } from '@/stores/auth/authSlice'
import { useConfirmationModalManagement } from '@/stores/ui/confirmationModalSlice'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { findWithIndex } from '@/utils/arrayHelper'
import { ContributorStatus, OfferApprovalType } from '@/features/offers/constants'
import { offerActionGroupPolicyType } from '@/features/offers/constants/offerEditRights/offerActionEditRights'
import { formatOffer } from '@/features/offers/helpers/formatOffer'
import useOffer from '@/features/offers/hooks/useOffer'
import { selectOfferDetail, selectOfferPermissions } from '@/features/offers/slices/offerDetail.slice'
import useOfferApproval from '@/features/offers/hooks/useOfferApproval'

const ContributionButtonGroup = () => {
  const offerPermissions = useSelector(selectOfferPermissions)
  const { adminMode } = useSelector(selectOfferDetail)
  const { user: currentUser } = useSelector(authSelector)
  const dispatch = useDispatch()
  const { clearErrors, getValues, formState } = useFormContext()
  const { open: openConfirmationModal } = useConfirmationModalManagement()

  const { useUpdateOffer } = useOffer()
  const updateOffer = useUpdateOffer()
  const canReviewContribution = offerPermissions[offerActionGroupPolicyType.ACTION_REVIEW_CONTRIBUTION]?.edit ?? false
  const canReviewOptionalContribution =
    offerPermissions[offerActionGroupPolicyType.ACTION_REVIEW_OPTIONAL_CONTRIBUTION]?.edit ?? false
  const canCommentContribution = offerPermissions[offerActionGroupPolicyType.ACTION_COMMENT_CONTRIBUTION]?.edit ?? false

  const handleOpenApprovalModal = async (approvalType) => {
    //Check if the user has update the offer, need them confirm before any action
    const currentOffer = getValues()

    const { isDirty, dirtyFields, touchedFields } = formState
    if (isDirty || Object.keys(dirtyFields).length > 0 || Object.keys(touchedFields).length > 0) {
      //Form has been
      const { isConfirmed } = await openConfirmationModal({
        title: 'Confirm changes to the offer',
        message: "You've modified the offer, are you sure to save the changes to proceed ? ",
      })

      if (!isConfirmed) {
        //Stop current action, and don't open approval modal
        return
      }

      try {
        dispatch(showLoadingOverlay())

        const formattedOffer = formatOffer(currentOffer)

        await updateOffer.mutateAsync({
          id: currentOffer._id,
          data: formattedOffer,
        })
      } catch (error) {
        return
      } finally {
        dispatch(hideLoadingOverlay())
      }
    }

    //Find detail

    let updatePath = ''
    let remark = ''
    let approverType = ''
    let approverLevel = -1
    switch (approvalType) {
      case OfferApprovalType.CONTRIBUTION_REVIEW:
      case OfferApprovalType.CONTRIBUTION_COMMENT: {
        const { index, object: contributorDetail } = findWithIndex(
          currentOffer.contributors,
          (detail) => detail?.user?._id === currentUser._id
        )
        updatePath = `contributors.${index}`

        remark = contributorDetail?.status === ContributorStatus.REQUIRED ? contributorDetail?.remark : ''
        break
      }
      case OfferApprovalType.OPTIONAL_CONTRIBUTION_REVIEW: {
        const { index, object: contributorDetail } = findWithIndex(
          currentOffer.optionalContributors,
          (detail) => detail?.user?._id === currentUser._id
        )
        updatePath = `optionalContributors.${index}`

        remark = contributorDetail?.status === ContributorStatus.REQUIRED ? contributorDetail?.remark : ''
        break
      }

      default:
        console.error(123)
    }

    dispatch(
      showApprovalRemarkModal({
        approvalType: approvalType,
        offerId: currentOffer._id,
        remark: remark,
        updatePath: updatePath,
        approverType: approverType,
        approverLevel: approverLevel,
      })
    )

    //
  }
  return (
    <>
      {canReviewContribution && !adminMode && (
        <Button colorScheme="green" onClick={() => handleOpenApprovalModal(OfferApprovalType.CONTRIBUTION_REVIEW)}>
          Review
        </Button>
      )}

      {canReviewOptionalContribution && !adminMode && (
        <Button
          colorScheme="green"
          onClick={() => handleOpenApprovalModal(OfferApprovalType.OPTIONAL_CONTRIBUTION_REVIEW)}
        >
          Review
        </Button>
      )}

      {canCommentContribution && !adminMode && (
        <Button colorScheme="red" onClick={() => handleOpenApprovalModal(OfferApprovalType.CONTRIBUTION_COMMENT)}>
          Comment
        </Button>
      )}
    </>
  )
}

export default ContributionButtonGroup
